import { Component, Inject, Input, EventEmitter, Output, ViewChild } from '@angular/core';

import { Subject } from 'rxjs';

import { MultiFilterableSelectComponent } from '../../../../shared/filterable-select/components/multi-filterable-select.component';

import { GroupementParcService } from '../../groupement-parc/services/groupement-parc.service';

import { ParcService } from '../services/parc.service';
import { ParcTLR } from '../entities/parc-tlr.entity';

@Component({
	selector: 'parc-by-groupement-multi-selector',
	templateUrl: 'parc-by-groupement-multi-selector.html',
})
export class ParcByGroupementMultiSelectorComponent {
	
	maxNumberOfSelections: number = 1;
	
	parcs: ParcTLR[] = [];
	suggestableParcs: ParcTLR[] = [];

	getParcLabel = (parc: ParcTLR) => {
		if (parc) {
			return parc.code + ' (' + (parc.description ? parc.description : '') + ')'
		}
		return '';
	};
	isParcPreselected = (parc: ParcTLR) => this._selectedParcIds.includes(parc.id);
	
	reinitSubject = new Subject<void>();

	constructor( //
		@Inject(GroupementParcService) private gpService: GroupementParcService, //
		@Inject(ParcService) private parcService: ParcService //
	) { }

	@ViewChild(MultiFilterableSelectComponent) input!: MultiFilterableSelectComponent;

	@Input() id!: string;
	@Input() disabled = false;
	
	// Classes pour l'affichege
	public _fieldClass: string = 'col-md-7';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}

	private _antenneId!: number | null | undefined;
	@Input() set antenneId(antenneId: number | null | undefined) {
		this._antenneId = antenneId;
		this.parcs = [];
		
		let parcs$ = 
			antenneId ? 
			this.parcService.getParcTLRByAntenne(antenneId) : 
			this.parcService.getParcTLRList()
		;
		
		parcs$.subscribe(
			(parcs : ParcTLR[]) => {
				this.parcs = parcs;
				if (this._energie) {
					this.suggestableParcs = parcs.filter( $ => $.energie === this._energie);
				} else {
					this.suggestableParcs = parcs;				
				}
			}
		);
	}

	private _energie!: string | null | undefined;
	@Input() set energie(energie: string | null | undefined) {
		if (energie) {
			this._energie = energie;
			this.parcs = [];
			
			let parcs$ = 
				this._antenneId ? 
				this.parcService.getParcTLRByAntenne(this._antenneId) : 
				this.parcService.getParcTLRList()
			;
			
			parcs$.subscribe(
				(parcs : ParcTLR[]) => {
					this.parcs = parcs;
					this.suggestableParcs = parcs.filter( $ => $.energie === energie);
				}
			);
		}
	}
	
	private _selectedParcIds: number[] = [];
	@Input() set selectedParcIds(ids: number[] | undefined) {
		if (ids != undefined) {
			this._selectedParcIds = ids;
			this.reinitSubject.next();
		}
	}
	get selectedParcIds(): number[] | undefined {
		return this._selectedParcIds;
	}
	
	@Output() selectedParcIdsChange = new EventEmitter<number[]>();
	
	@Output() selectedParcsChange = new EventEmitter<ParcTLR[]>();
	
	onSelectedParcsChange(parcs: ParcTLR[]) {
		let ids = parcs.map((parc: ParcTLR) => parc.id);
		this._selectedParcIds = ids;
		this.selectedParcIdsChange.emit(ids);
		this.selectedParcsChange.emit(parcs);
		if (ids.length === 1) {
			// premier parc choisi: on vérifie s'il a des siblings dans un groupements
			// si oui : reduire la liste des parcs à ces siblings puis augmenter maxNumberOfSelections
			this.gpService.findParcSiblings(ids[0]).subscribe(
				(siblingsIds : number[]) => {
					if (siblingsIds.length) {
						this.suggestableParcs = this.parcs.filter( parc => siblingsIds.indexOf(parc.id) > -1 );
						this.maxNumberOfSelections = siblingsIds.length;
					}
				}
			);
		} else if (ids.length === 0) {
			// on a remis à zero les choix des parcs
			if (this._energie) {
				this.suggestableParcs = this.parcs.filter( $ => $.energie === this._energie);
			} else {
				this.suggestableParcs = this.parcs;
			}
			this.maxNumberOfSelections = 1;
		}
	}
}